import React from "react";
import arrow from "./arrow.png";

function Arrow(props) {
  return <img src={arrow} alt="Rivile-mscan" {...props} />;
}

export default Arrow;
